(function() {
  'use strict';

  var KLAVIYO_PUBLIC_KEY = 'SbKUWL';
  var KLAVIYO_REVISION = '2024-10-15';

  // ---- URL params ----
  var params = new URLSearchParams(window.location.search);
  var profileId = params.get('id');

  // ---- DOM refs ----
  var wrapper = document.getElementById('birthday-capture-wrapper');
  var fallback = document.getElementById('birthday-capture-fallback');
  var form = document.getElementById('birthday-capture-form');
  var submitBtn = document.getElementById('birthday-capture-submit');
  var submitLabel = submitBtn ? submitBtn.querySelector('span') : null;
  var generalError = document.getElementById('birthday-capture-general-error');
  var successEl = document.getElementById('birthday-capture-success');

  // ---- Guard: missing id param ----
  if (!profileId) {
    if (wrapper) wrapper.style.display = 'none';
    if (fallback) fallback.style.display = 'block';
    return;
  }

  // ---- Helpers ----
  function getVal(id) {
    var el = document.getElementById(id);
    return el ? el.value.trim() : '';
  }

  function showErrors(errors) {
    var errorEls = form.querySelectorAll('.birthday-capture-form__error');
    for (var i = 0; i < errorEls.length; i++) {
      errorEls[i].textContent = '';
      errorEls[i].style.display = 'none';
    }
    for (var key in errors) {
      var el = form.querySelector('[data-error-for="' + key + '"]');
      if (el) {
        el.textContent = errors[key];
        el.style.display = 'block';
      }
    }
  }

  // ---- Submit handler ----
  form.addEventListener('submit', function(e) {
    e.preventDefault();

    // Honeypot
    // Honeypot: a bot filled the hidden field. Show the normal success state so it cannot tell it was caught; send nothing.
    if (document.getElementById('website-hp').value !== '') {
      if (form) form.style.display = 'none';
      if (successEl) successEl.style.display = 'block';
      return;
    }

    // Validate
    var bdayDay = getVal('birthday-capture-bday-day');
    var bdayMonth = getVal('birthday-capture-bday-month');
    var bdayYear = getVal('birthday-capture-bday-year');

    if (!bdayDay || !bdayMonth || !bdayYear) {
      showErrors({ birthday: 'Birthday is required.' });
      return;
    }

    showErrors({});
    if (generalError) generalError.style.display = 'none';

    // Disable button
    submitBtn.disabled = true;
    if (submitLabel) submitLabel.textContent = 'Saving\u2026';

    // Format birthday YYYY-MM-DD
    var birthday = bdayYear + '-' + String(bdayMonth).padStart(2, '0') + '-' + String(bdayDay).padStart(2, '0');

    // ---- Klaviyo profile update ----
    fetch('https://a.klaviyo.com/client/profiles/?company_id=' + KLAVIYO_PUBLIC_KEY, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': KLAVIYO_REVISION
      },
      body: JSON.stringify({
        data: {
          type: 'profile',
          id: profileId,
          attributes: {
            properties: {
              birthday: birthday,
              birthday_set: true
            }
          }
        }
      })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Klaviyo responded ' + res.status);
      // Success — show success state
      if (form) form.style.display = 'none';
      if (successEl) successEl.style.display = 'block';
    })
    .catch(function(err) {
      console.error('Birthday update error:', err);
      submitBtn.disabled = false;
      if (submitLabel) submitLabel.textContent = 'Save';
      if (generalError) generalError.style.display = 'block';
    });
  });
})();
